
import {Component, Mixins} from 'vue-property-decorator';
import {deleteTenant, getTenants} from '@pazion/pazion-core/src/services/auth-service';
import PazRefreshButton from "@pazion/pazion-core/src/components/controls/PazRefreshButton.vue";
import DataDialog from "@pazion/pazion-core/src/components/utils/DataDialog.vue";
import PazTextSearch from "@pazion/pazion-core/src/components/controls/PazTextSearch.vue";
import PazListFilterSelector from "@pazion/pazion-core/src/components/utils/PazListFilterSelector.vue";
import PazTooltipButton from "@pazion/pazion-core/src/components/controls/PazTooltipButton.vue";
import PazConfirmation from "@pazion/pazion-core/src/components/utils/PazConfirmation.vue";
import PazTooltipText from "@pazion/pazion-core/src/components/controls/PazTooltipText.vue";
import EntityLogMixin from "@pazion/pazion-core/src/mixins/EntityLog.mixin";
import EntityLogDialog from "@pazion/pazion-core/src/components/utils/EntityLogDialog.vue";
import pazTenantEditDialog from "@pazion/pazion-core/src/views/tenant/modals/pazTenantEditModal.vue";
import {DataTableHeader} from "vuetify";


@Component({
  components: {
    PazTooltipText,
    DataDialog,
    PazRefreshButton,
    PazTextSearch,
    PazListFilterSelector,
    PazTooltipButton,
    PazConfirmation,
    EntityLogDialog,
    pazTenantEditDialog
  }
})
export default class TenantListing extends Mixins(EntityLogMixin) {

  public dialog = false;
  public loading: boolean = false;
  public selectedTenantId: number | null = null;
  public search: string = '';
  public items = [];
  public headers: DataTableHeader[] = [
    {
      text: 'id',
      align: 'start',
      sortable: true,
      value: 'id',
      class: 'nowrap',
      cellClass: 'nowrap',
    },
    {
      class: 'nowrap',
      cellClass: 'nowrap',
      text: 'Name',
      align: 'start',
      sortable: true,
      value: 'name',
    },
    {
      class: 'nowrap',
      cellClass: 'nowrap',
      text: 'Account reference',
      align: 'start',
      sortable: true,
      value: 'accountReference',
    }, {
      class: 'nowrap',
      cellClass: 'nowrap',
      text: 'Active',
      align: 'end',
      sortable: true,
      value: 'isActive',
    },
    {
      class: 'nowrap',
      cellClass: 'nowrap justify-end',
      text: 'Created at',
      align: 'end',
      sortable: true,
      value: 'createdAt',
    },
    {
      text: "Action",
      align: "end",
      sortable: false,
      value: "extra",
    }
  ];
  showEditTenantDialog: boolean = false;

  get filteredItems() {
    return this.items;
  }

  mounted() {
    this.fetchData();
  }

  async fetchData() {
    this.loading = true;
    this.items = await getTenants();
    this.loading = false;
  }

  triggerTenantEditDialog(id: number | null, isClose: boolean) {
    this.selectedTenantId = id;
    this.showEditTenantDialog = !isClose;
  }

  async deleteTenants(item: any) {
    const confirm = await this.$refs.confirmDeleteTenant.openConfirmDialog(
        "Delete",
        `Do you want to delete tenant ${item.name}?`
    );
    if (confirm) {
      const rsp = await deleteTenant(item.id);
      if (rsp.id > 0) {
        await this.fetchData();
      }
    }
  }
}
